"use client";
import React, { Fragment } from "react";
import { useAuth } from "@/contexts/authContext";
import { truncateText } from "@/utils/generalutils";

const LoginButton = () => {
  const {
    isAuthenticated,
    isFetchingUser,
    isWalletConnecting,
    walletAddress,
    isAdminAuthenticated,
  } = useAuth();

  return (
    <Fragment>
      {!isAuthenticated && !isFetchingUser && (
        <div className="hover:jello-horizontal">
          <w3m-connect-button />
        </div>
      )}

      {isAuthenticated && !isFetchingUser && !isAdminAuthenticated && (
        <w3m-account-button balance="hide" />
      )}

      {isAdminAuthenticated && walletAddress && !isFetchingUser && (
        <div className="flex items-center gap-2 bg-gradient-to-r from-metaxseed-blue/50 via-metaxseed-light-green/20 to-metaxseed-blue/50 rounded-full text-metaxseed-light-green py-2 px-4 shadow-3d transform hover:scale-105 transition-transform duration-300 animate-shine">
          {truncateText(walletAddress, 4, 4)}
        </div>
      )}
    </Fragment>
  );
};

export default LoginButton;
